module.exports = __webpack_public_path__ + "files/6789f51508f7627b03872fb6cb980550.png";